<div class="section">
  <div class="section-content">
    <div class="hidden block-md mt-28">
      <button class="button button-subtle" (click)="onBack()">
        &#8592; Назад
      </button>
    </div>
  </div>
</div>
<app-breadcrumb
  *ngIf="breadcrumbs$ | async as breadcrumbs"
  [backButton]="false"
  [title]="header"
  [items]="breadcrumbs"
></app-breadcrumb>
<ng-template #header>
  <div
    *ngIf="(item$ | async | analyseTypeCheck)?.hxid"
    class="hidden-md typography typography-body grey-700 typography-paragraph"
  >
    <span class="tag">{{ (item$ | async | analyseTypeCheck)?.hxid }}</span>
  </div>

  <div class="grid">
    <div class="grid-item grid-9 grid-md-12">
      <h1 class="typography typography-h1 pageheader-title">
        <div class="pageheader-back-button link" (click)="onBack()"></div>
        {{ (item$ | async)?.title }}
      </h1>
    </div>
  </div>
</ng-template>

<app-skeleton *ngIf="!(isLoaded$ | async)"></app-skeleton>

<nz-result
  *ngIf="(isLoaded$ | async) && (showError$ | async)"
  class="result-status-404"
  nzStatus="404"
  nzTitle="404"
  nzSubTitle="К сожалению, этой страницы нет на сайте"
>
  <div nz-result-extra>
    <a class="button button-primary" routerLink="/kb">Вернуться в раздел</a>
  </div>
</nz-result>

<div class="section section-has-sider" *ngIf="item$ | async as item">
  <div class="section-content section-sider-mobile-top grid">
    <div class="section-main min-w-128">
      <div *ngIf="item.kbInfo" [innerHTML]="item.kbInfo | kbInfo"></div>
      <app-backtop></app-backtop>
    </div>
    <div class="section-sider grid-item grid-4 grid-sm-12">
      <div class="affix affix-top-40">
        <app-helixbook-price
          *ngIf="item | analyseTypeCheck"
          [item]="item | analyseTypeCheck"
        ></app-helixbook-price>
        <app-anchor-list
          [info]="item.kbInfo"
          [isAnalyse]="!!(item | analyseTypeCheck)"
        ></app-anchor-list>
        <app-helixbook-example-file
          *ngIf="(item | analyseTypeCheck)?.hasExampleFile"
          [hxid]="(item | analyseTypeCheck)?.hxid ?? ''"
        ></app-helixbook-example-file>
      </div>
    </div>
  </div>
</div>
